module.exports = __webpack_public_path__ + "static/media/event-4.dfbb0888.jpg";